import { getMessages } from '../../../../../../store/constants';

export const TRIAL_EXTEND_TITLE = getMessages().getText('dialog.blocker-trial-extend.title');
export const TRIAL_EXTEND_LABEL = getMessages().getText('dialog.blocker-trial-extend.label');
export const TRIAL_EXTEND_SUBMIT = getMessages().getText('dialog.blocker-trial-extend.button');
